import {get, post, del, patch} from "../api"
import * as url from "../url"
import { format } from 'react-string-format';

const apiGetUserPermissionsList = data => {
  return get(format(url.API_USER_PERMISSIONS, data.userId), data.history)
}

const apiPostUserPermissionsNew = data => {
  return post(format(url.API_USER_PERMISSIONS, data.userId), data.history, data.values)
}

const apiPatchUserPermissionsEdit = data => {
  return patch(format(url.API_USER_PERMISSIONS_DETAIL, data.userId, data.permissionId), data.history, data.values)
}

const apiDeleteUserPermissionsDelete = data => {
  return del(format(url.API_USER_PERMISSIONS_DETAIL, data.userId, data.permissionId), data.history)
}

const apiGetUserPermissionsTypesList = data => {
  return get(format(url.API_USER_PERMISSIONS_TYPES, data.userId), data.history)
}

const apiGetSectionsList = data => {
  return get(url.API_SECTIONS + "simple/", data.history)
}

const apiGetSegmentsList = data => {
  return get(url.API_SEGMENTS + "simple/", data.history)
}

export {
  apiGetUserPermissionsList,
  apiPostUserPermissionsNew,
  apiPatchUserPermissionsEdit,
  apiDeleteUserPermissionsDelete,
  apiGetUserPermissionsTypesList,
  apiGetSectionsList,
  apiGetSegmentsList,
}
